/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Type_Date4Inputs */

const en__field__enum_type_date4 = /** @type {(inputs: _Field__Enum_Type_Date4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

/** @type {(inputs: _Field__Enum_Type_Date4Inputs) => LocalizedString} */
const de__field__enum_type_date4 = en__field__enum_type_date4;

/**
* | output |
* | --- |
* | "Date" |
*
* @param {_Field__Enum_Type_Date4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_type_date4 = /** @type {((inputs?: _Field__Enum_Type_Date4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Type_Date4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_type_date4(inputs)
	return de__field__enum_type_date4(inputs)
});
export { _field__enum_type_date4 as "_field__enum_type_DATE" }